import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit User'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
